// Module
var code = "<div class=\"h-100 w-100 flex-container-row\">\n    <cjs-icon-fa ref=\"previousWeek\"></cjs-icon-fa>\n    <div ref=\"bookingContainer\" class=\"d-flex gap-1 pt-2\"></div>\n    <cjs-icon-fa ref=\"nextWeek\" class=\"nextWeek\"></cjs-icon-fa>\n</div>";
// Exports
module.exports = code;